module.exports = __webpack_public_path__ + "static/img/banner_investment.95fbf3be.png";